
import React, { Fragment } from "react";
import { Skeleton } from "antd";

type Props = {
    tr: number;
    td: number;
}

const SkeletonTable: React.FC<Props> = ({ tr, td }: Props) => {
    return (
        <Fragment>
            {
                Array.from({ length: tr }).map((_tr, i_tr) =>
                    <tr key={i_tr}>
                        {
                            Array.from({ length: td }).map((_td, i_td) =>
                                <td key={i_td}><Skeleton.Input active size={"small"} /></td>)
                        }
                    </tr>
                )
            }
        </Fragment>
    );
}

export default SkeletonTable;